import { useStoreConfig } from '~/store/storeConfig'

export default function (languageId: number | null): string[] {
  const site = useStoreConfig().getSite
  const currentLanguage = site?.languages?.find((predicate) => predicate.id === languageId)

  let pixelIds: string[] = []
  const rawPixelIds = currentLanguage?.pivot.pixel_id || null

  if (typeof rawPixelIds === 'string') {
    pixelIds = rawPixelIds
      .split(',')
      .map((predicate) => predicate.trim())
      .filter((predicate) => predicate.length >= 1)
  }

  return pixelIds
}
